import React, { useCallback, useEffect } from "react";
import { dataUrlToFile, isDataUrl } from "../../../../helpers/data-url";
import { hideImageMenu, showImageMenu } from "../../plugins/image-menu.plugin";
import { EditorImage } from "../EditorImage/EditorImage";
import { isValidProtocol } from "../../../url/utils";
import { dispatchEditorViewEvent } from "../../../../helpers/events";
export const ImageNodeView = ({ view, attrs, getPos, service, }) => {
    const handleCaptionChange = useCallback((caption) => {
        view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
            ...attrs,
            caption,
        }));
    }, [view, getPos, attrs]);
    const handleCaptionFocus = useCallback((event) => {
        dispatchEditorViewEvent(view, event);
    }, [view]);
    const handleCaptionBlur = useCallback((event) => {
        dispatchEditorViewEvent(view, event);
    }, [view]);
    const handleUpload = useCallback((url) => {
        const promise = isValidProtocol(url)
            ? getUploadFilePromise(service, url)
            : Promise.reject(new Error("Invalid image protocol"));
        promise
            .then((file) => {
            view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
                file,
                url: null,
            }));
        })
            .catch((e) => {
            const tr = view.state.tr;
            tr.deleteRange(getPos(), getPos() + 1);
            // insert an anchor link with url as href
            tr.insertText(url, getPos());
            tr.addMark(getPos(), getPos() + url.length + 1, view.state.schema.marks.link.create({ href: url }));
            view.dispatch(tr);
        });
    }, [service, view, getPos]);
    const handleResize = useCallback((size) => {
        view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
            ...attrs,
            size,
        }));
    }, [view, getPos, attrs]);
    const handleChangeMenuVisibility = useCallback((visible, target) => {
        if (visible) {
            showImageMenu(view, target.closest(".editor-image"));
        }
        else {
            hideImageMenu(view);
        }
    }, [view]);
    useEffect(() => {
        if (!attrs.url) {
            return;
        }
        handleUpload(attrs.url);
    }, [attrs.url, handleUpload]);
    if (attrs.url) {
        return (React.createElement("div", { className: "editor-image-placeholder" },
            React.createElement("img", { src: attrs.url, alt: attrs.caption })));
    }
    return (React.createElement(EditorImage, { attrs: attrs, service: service, editable: view.editable, onCaptionChange: handleCaptionChange, onCaptionFocus: handleCaptionFocus, onCaptionBlur: handleCaptionBlur, onResize: handleResize, onChangeMenuVisibility: handleChangeMenuVisibility }));
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
function getUploadFilePromise(service, url) {
    if (isDataUrl(url)) {
        const file = dataUrlToFile(url, "image.png");
        if (!file)
            return Promise.reject(new Error("Invalid file."));
        return service.uploadFile(file);
    }
    return service.uploadByUrl(url);
}
